import { useState, useEffect } from "react";
import PageTitle from "../../../components/PageTitle/PageTitle";
import Button from "../../../components/Button/Button";
import Modal from "../../../components/Modal/index";
import TabContext from "@mui/lab/TabContext";
import Tab from "@mui/material/Tab";
import Tabs from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import Teachers from "./Teachers";
import NonTeaching from "./NonTeaching";
import AllEmployees from "./AllEmployees";
import SelectGroup from "../../../components/FormComponent/SelectGroup";
import { Grid } from "@mui/material";
import { toast, ToastContainer } from "react-toastify";
import InputGroup from "../../../components/FormComponent/InputGroup";
import { httprequest } from "../../../data/api";
import useValidator from "../../../hooks/useValidator";
// import TerminatedEmployees from "./TerminatedEmployees";
import PageLoader from "../../../components/PageLoader/pageloader";
import BulkEmployee from "../../../components/BulkEmployeeCard/index";
import { useParams } from "react-router-dom";
// import { useUserState } from "../../context/UserContext";
const EMPLOYEES_ENDPOINT = "/admin/v1/teachers";
const ROLES_ENDPOINT = "/admin/v1/roles";

const StaffMembers = () => {
  // const { userRole } = useUserState();
  const [value, setValue] = useState("");
  const [createModal, setCreateModal] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [employeesData, setEmployeesData] = useState([]);
  const [rolesData, setRolesData] = useState([]);
  const [isPageLoading, setIsPageLoading] = useState(false);
  const [employeeValidator, showValidationMessage] = useValidator();
  const [bulkModal, setBulkModal] = useState(false);
  const { id } = useParams();

  const [inviteForm, setInviteForm] = useState({
    email: "",
    role: "0e43e70c-de29-46cd-9aef-9d26cc959e62",
    job_title: ""
    // org_id: userRole?.org_id
  });

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const handleCreateChange = (e) => {
    const { name, value } = e.target;
    setInviteForm({ ...inviteForm, [name]: value });
  };

  const handleCloseCreateModal = () => {
    setCreateModal(false);
    setInviteForm({ ...inviteForm, email: "", role: "", job_title: "" });
  };

  const handleCreateBulkModal = () => {
    setBulkModal(!bulkModal);
  };

  const handleCreateModal = () => {
    setCreateModal(!createModal);
  };

  const getEmployeeData = () => {
    setIsPageLoading(true);
    const endpoint = value === "inactive"
      ? `${EMPLOYEES_ENDPOINT}/${id}?active=false`
      : `${EMPLOYEES_ENDPOINT}/${id}`;

    httprequest
      .get(endpoint)
      .then((res) => {
        setEmployeesData(res?.data?.data);
        setIsPageLoading(false);
      })
      .catch((err) => {
        setIsPageLoading(false);
        toast.error(err?.response?.data);
      });
  };

  // const activeEmployees = employeesData?.filter(employee => employee?.is_active === true);

  const handleCreateBatchEmployee = async (file) => {
    setIsLoading(true);

    const formData = new FormData();
    formData.append("file", file);

    try {
      const res = await httprequest.post(`/admin/v1/${id}/employees/batch`, formData);
      toast.success(res?.data?.message);
      getEmployeeData();
      setBulkModal(false);
    } catch (err) {
      toast.error(err?.response?.data?.message);
    } finally {
      setIsLoading(false);
    }
  };

  const handleCreateEmployee = () => {
    if (employeeValidator.allValid()) {
      setIsLoading(true);
      httprequest.post(`/admin/v1/${id}/employees`, { recipients: [inviteForm] }).then(() => {
        setIsLoading(false);
        toast.success("Invite sent successfully");
        handleCloseCreateModal();
        getEmployeeData();
      }).catch((err) => {
        setIsLoading(false);
        toast.error(err?.response?.data?.message);
      });
    } else {
      showValidationMessage(true);
    }
  };

  const getRoles = () => {
    httprequest.get(`${ROLES_ENDPOINT}/${id}`).then((res) => {
      const updatedEmployee = res?.data?.data?.filter((newrole) => newrole?.role_type !== "school_admin" && newrole?.role_type !== "guardian" && newrole?.role_type !== "student");
      setRolesData(updatedEmployee);
    }).catch(() => {

    });
  };
  // eslint-disable-next-line no-console
  console.log(rolesData, "Role Data");

  useEffect(() => {
    getRoles();
  }, []);

  useEffect(() => {
    if (value !== "terminated") {
      getEmployeeData();
    }
  }, [value]);

  const { job_title, email, role } = inviteForm;

  return (
    <div className="padding-right padding-bottom">
      <PageTitle
        title="Employees"
        subtitle="See all the employees in your organisation."
        button={
          <div className="flex gap-10">
            <Button
              variant="primaryoutline"
              buttonSize="fluid"
              color="btnfontprimary"
              onClick={handleCreateBulkModal}
              buttonName="Add Batch Employee"
            />
            <Button
              variant="primary"
              buttonSize="small"
              color="btndefault"
              buttonName="Add an Employee"
              onClick={handleCreateModal}
            />
          </div>
        }
      />
      <div className="">
        <TabContext value={value}>
          <div className="tablist-container">
            <Tabs indicatorColor="none" className="overide-tablist" onChange={handleChange} aria-label="lab API tabs example">
              <Tab label="All" value="" />
              <Tab label="Active" value="active" />
              <Tab label="Inactive" value="inactive" />
              {/* <Tab label="Terminated Staff" value="terminated" /> */}
            </Tabs>
          </div>
          {isPageLoading ? (
            <PageLoader />
          ) : (
            <>
              <TabPanel value="" className="tabpanel-overide">
                <AllEmployees data={employeesData} />
              </TabPanel>
              <TabPanel value="active" className="tabpanel-overide"> <Teachers data={employeesData?.filter(active => active?.is_active === true)} /></TabPanel>
              <TabPanel value="inactive" className="tabpanel-overide"> <NonTeaching data={employeesData?.filter(active => active?.is_active === false)} /></TabPanel>
              {/* <TabPanel value="terminated" className="tabpanel-overide"> <TerminatedEmployees /></TabPanel> */}
            </>
          )}
        </TabContext>
        <Modal
          title="Create Employee"
          subtitle={
            <div>Add this Employee into your school, on create, they will receive an email to create that password.
            </div>}
          modalContent={
            <>
              <Grid container spacing={2} className="input-padding">
                <Grid item lg={6} md={6} sm={12} xs={12}>
                  <InputGroup
                    label="Job Title"
                    margin="normal"
                    inputType="text"
                    inputName="job_title"
                    inputValue={job_title}
                    onChange={handleCreateChange}
                    required
                  />
                  {employeeValidator.message("job_title", job_title, "required")}
                </Grid>
                <Grid item lg={6} md={6} sm={6} xs={12}>
                  <InputGroup
                    label="Email Address"
                    margin="normal"
                    inputType="email"
                    inputName="email"
                    inputValue={email}
                    onChange={handleCreateChange}
                    required
                  />
                  {employeeValidator.message("email", email, "required")}
                </Grid>
                <Grid item lg={6} md={6} sm={6} xs={12}>
                  <SelectGroup label="Role" required children={
                    <select onChange={handleCreateChange} value={role} name="role">
                      <option value="">--- Select ---</option>
                      {rolesData?.map((role) => {
                        return (
                          <option key={role?.role_name} value={role?.role_id}>{role?.role_name}</option>
                        );
                      })}
                    </select>
                  }
                  />
                  {employeeValidator.message("role", role, "required")}
                </Grid>
              </Grid>
            </>
          }
          modalFooter={
            <>
              <Button variant="primary" buttonName="Create Employee" buttonSize="full" color="btndefault" onClick={handleCreateEmployee} isLoading={isLoading} />
            </>
          }
          isopen={createModal}
          closeModal={handleCloseCreateModal}
        />
        {/* CREATE BULK EMPLOYEE */}
        <Modal
          title="Create Batch Employee"
          subtitle={
            <div>Create multiple employees at the same time by importing a csv file.
            </div>}
          modalContent={
            <>
              <Grid container spacing={2} className="input-padding">
                <Grid item lg={10} md={12} sm={12} xs={12}>
                  <p className="key-pair-name">1. Download sample .csv file here.</p>
                  <p className="key-pair-name">2. Fill in all columns. All fields are mandatory.</p>
                  {/* <p className="key-pair-name">3. Allowed staff types are academic teaching staffs.</p> */}
                  <p className="key-pair-name">3. Do not include extra columns nor rename columns in the document.</p>
                  <p className="key-pair-name">4. Upload the completed excel document</p>
                </Grid>
                <BulkEmployee
                  createClick={(file) => handleCreateBatchEmployee(file)}
                  isLoading={isLoading}
                />
              </Grid>
            </>
          }
          modalFooter={
            <>
            </>
          }
          isopen={bulkModal}
          closeModal={handleCreateBulkModal}
        />
        <ToastContainer />
      </div>
    </div>
  );
};

export default StaffMembers;
